<template>
  <div>
    <Tabs
      class="mt-6"
      :options="options"
      :expanded="false">
      <template #0>
        <BankEntries />
      </template>
      <template #1>
        <WalletsEntries />
      </template>
    </Tabs>
  </div>
</template>

<script>
import notification from '@/ui/mixins/notification';
import Tabs from '@/ui/components/Tabs.vue';
import BankEntries from './BankEntries.vue';
import WalletsEntries from './WalletsEntries.vue';

export default {
  components: { Tabs, BankEntries, WalletsEntries },
  mixins: [notification],
  data() {
    return {
      options: [
        {
          label: this.$t('treasury.bankEntries'),
          icon: 'bank'
        },
        {
          label: this.$t('treasury.walletsEntries'),
          icon: 'wallet'
        }
      ]
    };
  }
};
</script>

<style scoped>
  #block-filters {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
    align-content: center;
  }
  .notification {
    margin: 10px;
    border-radius: 25px;
    width: 60%;
    background-color: var(--primary);
    color: white;
    padding: 20px;
  }
  .notification-content {
    width: 95%;
    margin: 30px auto;
  }
  .notification-content .notification {
    background: transparent;
  }
  .spinner-content {
    position: inherit;
    margin: 60px;
  }
</style>
